export default function validate(values) {
    let errors = {};

    if (values.password === '') {
        errors.password = 'Password is required';
    }
    if (values.name === '') {
        errors.name = 'Name is required';
    }
    // if (values.arabic_name === '') {
    //     errors.arabic_name = 'Arabic Name is required';
    // }
    if (values.email === '') {
        errors.email = 'Email address is required';
    }
    if (values.attribute_value === '') {
        errors.attribute_value = 'Value is required';
    }
    if (values.list_type === '') {
        errors.list_type = 'Type is required';
    }
    if (values.list_key === '') {
        errors.list_key = 'Key is required';
    }
    if (values.list_lable === '') {
        errors.list_lable = 'Label is required';
    }
    if (values.value === '') {
        errors.value = 'Value is required';
    }
    if (values.module === '') {
        errors.module = 'Module is required';
    }
    if (values.display_order === '') {
        errors.display_order = 'Display Order is required';
    }
    if (values.lastname === '') {
        errors.lastname = 'Last Name is required';
    }
    if (values.firstname === '') {
        errors.firstname = 'First Name is required';
    }
    if (values.phone === '') {
        errors.phone = 'Phone is required';
    }

    if (values.business_name === "") {
        errors.business_name = "Bussiness Name is required";
    }

    if (values.contact_person === "") {
        errors.contact_person = "Contact Person is required";
    }

    if (values.bank_details === "") {
        errors.bank_details = "Bank details are required";
    }
    if (values.business_address == "") {
        errors.business_address = "bussiness address is required";
    }

    if (values.bank_details == "") {
        errors.bank_details = "bank details are required";
    }

    if (values.pan === "") {
        errors.pan = "PanCard is required";
    }

    if (values.vatid === "") {
        errors.vatid = "VatId is required";
    }

    if (values.emailid == "") {
        errors.emailid = "emailid is required";
    }

    if (values.contact_phone === "") {
        errors.contact_phone = "contact number is required";
    }

    if (values.emaiid === "") {
        errors.emaiid = "Email id is required";
    }

    if (values.new_password === "") {
        errors.new_password = `New password is required.`;
    }

    if (values.old_password === "") {
        errors.old_password = "Old password is required";
    }
    if (values.searchkeyword === "") {
        errors.searchkeyword = "Searchkeyword is required";
    }
    if (values.url === "") {
        errors.url = "Url is required";
    }



    if (values.confirm_password !== values.new_password) {
        errors.confirm_password = "Passwords do not match";
    }
    if (values.userrname === "") {
        errors.userrname = "Username is required";
    }
    if (values.department === "") {
        errors.department = "Department is required";
    }
    if (values.groups === "") {
        errors.groups = "Group is required";
    }

    if (values.confirmPassword === "") {
        errors.confirmPassword = "Confirm password is required"
    }

    if (values.newPassword === "") {
        errors.newPassword = "New password is required"
    }

    if (values.otp === "") {
        errors.otp = "Otp is required"
    }



    if (values.newPass === "") {
        errors.newPass = "Password is required";
    }

    if (values.repeatPass === "") {
        errors.repeatPass = "Please confirm your password";
    }

    if (values.newPass && values.repeatPass && values.newPass !== values.repeatPass) {
        errors.repeatPass = "Passwords do not match";
    }

    if (values.notes === "") {
        errors.notes = "Notes can't be empty"
    }

    return errors;
};